/* eslint-disable camelcase */
import isMSLegacy from "common/utils/is-ms-legacy";
import {
  getStepData,
  LEGACY_getStepData,
  LEGACY_saveStepData,
  saveStepData,
} from "features/budget/wizard/state/wizard.storage";

const STEP = 5;

export async function saveOwnerAssignments(assignments) {
  if (isMSLegacy() === true) {
    LEGACY_saveStepData(STEP, assignments);
  } else {
    await saveStepData(STEP, assignments);
  }
}

export async function getOwnerAssignments() {
  let ownerAssignments;

  if (isMSLegacy() === true) {
    ownerAssignments = LEGACY_getStepData(STEP);
  } else {
    ownerAssignments = await getStepData(STEP);
  }
  return ownerAssignments;
}

export async function clearOwners() {
  await saveOwnerAssignments(undefined);
}
